import React from 'react';

import imageDenied from 'assets/img/ufo.svg';

import styles from './AccessDeniedPage.module.less';

export default function AccessDeniedPage() {
  return (
    <div className="scroll-box">
      <div className={styles.accessDeniedPage}>
        <div className={styles.imageBox}>
          <img src={imageDenied} alt="access denied" />
        </div>
        <div className={styles.titleBox}>
          <h1 className={styles.title}>
            Looks like this page is not available.
          </h1>
          <h2 className={styles.subTitle}>
            If you have another account, switch to it and try again.
          </h2>
        </div>
      </div>
    </div>
  );
}
